import React, { useCallback, useMemo, useState } from 'react'
import Carousel from 'components/Luxkit/Carousel/Carousel'
import HostCard from './HostCard'
import { rem } from 'polished'
import styled from 'styled-components'
import debounce from 'debounce-promise'
import Group from 'components/utils/Group'
import Bubbles from './Bubbles'
import noop from 'lib/function/noop'

const Page = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-flow: row;
  grid-row-gap: ${rem(40)};
`

const StyledCarousel = styled(Carousel)`
  width: 100%;
`

interface Props {
  hosts: App.MarketingLeTVHostDetail[]
}

function MobileHostCarousel({ hosts }: Props) {
  const [currentPage, setCurrentPage] = useState<number>(0)
  const pages = useMemo(() => {
    const numberOfPages = Math.ceil(hosts.length / 4)
    return [...Array(numberOfPages).keys()].map(i => hosts.slice(4 * i, 4 * (i + 1)))
  }, [hosts])

  const updatePage = useMemo(() => {
    return debounce((left, width) => {
      setCurrentPage(Math.floor((left + Math.floor(left / width) * 13) / width))
    }, 32)
  }, [])

  const onScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    updatePage(e.currentTarget.scrollLeft, e.currentTarget.offsetWidth)
  }, [updatePage])

  return (
    <Group direction="vertical" horizontalAlign="center" gap={32}>
      <StyledCarousel width="100%" snap="start" onScroll={onScroll} gutterSize={0}>
        {pages.map((page, i) => (
          <Page key={i}>
            {page.map(host => (
              <HostCard
                key={host.name}
                name={host.name}
                description={host.description}
                imageId={host.image.id!}
                modalImageId={host.modalImage.id}
              />
            ))}
          </Page>
        ))}
      </StyledCarousel>
      <Bubbles count={4} active={currentPage} onSelect={noop} />
    </Group>
  )
}

export default MobileHostCarousel
